import React from "react";
import { customDateFormatWithTime, textFormatter } from "components/Common/formatter";
import { Tooltip } from "antd";
import CustomLink from "components/Common/buttons/CustomLink";
import { userHasOneOfRoles } from "utils/helpers/functions";
import { USER_ROLES } from "utils/constants";

const color = "#444444";

export const customerListColumns = () => [
  {
    title: "Customer ID",
    dataIndex: "id",
    render: textFormatter,
  },
  {
    title: "Full Name",
    dataIndex: "",
    render: row => {
      const fullName = `${row.firstName} ${row.lastName}`;
      if (userHasOneOfRoles([USER_ROLES.BUSINESS_DEV, USER_ROLES.TSS])) return textFormatter(fullName);

      return (
        <Tooltip placement="bottom" title={`${row.firstName} ${row.lastName} details`} color={color}>
          <div>
            {row.id.includes("%") ? (
              row.id
            ) : (
              <CustomLink to={`/customers/customer/${row.id}`}>{textFormatter(fullName)}</CustomLink>
            )}
          </div>
        </Tooltip>
      );
    },
  },
  {
    title: "Maintenance TSR",
    dataIndex: "technician",
    render: (cellContent, row) => {
      const { technician } = row;

      return technician ? (
        <CustomLink underlined target="_blank" to={`/user/${technician}`}>
          {technician}
        </CustomLink>
      ) : (
        textFormatter(technician)
      );
    },
  },
  {
    title: "Growth TSR",
    dataIndex: "growthTechnician",
    render: textFormatter,
  },
  {
    title: "CSA TSR",
    dataIndex: "csaTechnician",
    render: textFormatter,
  },
  {
    title: "Category",
    dataIndex: "type",
    render: textFormatter,
  },
  {
    title: "Phone",
    dataIndex: "phone",
    render: textFormatter,
  },
  {
    title: "Depot",
    dataIndex: "depot",
    render: cellContent => (
      <CustomLink underlined to={`/depots/depot?name=${cellContent}`} target={"_blank"}>
        {cellContent}
      </CustomLink>
    ),
  },
  {
    title: "Package",
    dataIndex: "packageName",
    render: textFormatter,
  },
  {
    title: "Installation Date",
    dataIndex: "installationDate",
    render: cellContent => textFormatter(customDateFormatWithTime(cellContent)),
  },
];
